// extracted by mini-css-extract-plugin
export default {"tableContainer":"Licenses-module_tableContainer__aYanW"};